<template>
    <l-layout :layout="['xs12']">
      <v-form ref="appForm">
        <v-layout column>
          <v-layout>
            <v-flex xs6>
              <v-text-field label="名称" prepend-icon="$vuetify.icons.title" v-model="form.name"
              :disabled="disabledFlag"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field label="路径" prepend-icon="$vuetify.icons.title" v-model="form.path"
                            :disabled="disabledFlag"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-textarea label="描述" v-model="form.description" prepend-icon="$vuetify.icons.comment" rows="1" auto-grow
                        :disabled="disabledFlag"></v-textarea>
          </v-layout>
          <l-select-file
            :dialog-props="form.packageProps"
            @cancel="apkProps.activate = false"
            @submit="uploadApk"
            select-type="dialog"
            :disabled="disabledFlag"
          >
            <v-btn class="mx-0" color="primary" flat  :loading="loading"
                   :disabled="disabledFlag"
                   slot="activator">上传硬件程序管理包
            </v-btn>
          </l-select-file>
        </v-layout>
      </v-form>
    </l-layout>
</template>

<script>
    export default {
      name: "newIotPackage",
      data(){
        return {
          form:{
            packageProps: {
              activate: true,
              autoClose: true,
              title: '上传硬件程序管理包'
            },
            name:'',
            description:'',
            path:'',
          },
          disabledFlag:false,
          loading:false
        }
      },
      methods:{
        async uploadApk (files) {
          let f = files[0]
          let formData = new FormData()
          formData.append('file', f)
          formData.append('name',this.form.name)
          formData.append('path',this.form.path)
          formData.append('description',this.form.description)
          this.loading = true
          try{
            let res = await this.$store.dispatch('iot/uploadApk', {formData:formData})
            console.log(res)
            this.loading = false
            if (res.data.status + '' === '200') {
              this.$L.alert('success', {message: '上传成功'})
              this.disabledFlag = true
            }
            else {
              this.$L.alert('error', {message: '上传失败，原因:' + res.data.msg})
            }
          }catch (e) {
            this.loading = false

          }
        },
      }
    }
</script>

<style scoped>

</style>
